import React, { useEffect } from 'react';
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-react';

function Toast({ message, type = 'success', onClose, duration = 3000 }) {
  const isMobile = window.innerWidth <= 480;

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const getIcon = () => {
    const size = isMobile ? 20 : 24;
    switch (type) {
      case 'success':
        return <CheckCircle size={size} />;
      case 'error':
        return <XCircle size={size} />;
      case 'warning':
        return <AlertCircle size={size} />;
      case 'info':
        return <Info size={size} />;
      default:
        return <CheckCircle size={size} />;
    }
  };

  const getStyles = () => {
    switch (type) {
      case 'success':
        return {
          background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
          color: 'white'
        };
      case 'error':
        return {
          background: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
          color: 'white'
        };
      case 'warning':
        return {
          background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          color: 'white'
        };
      case 'info':
        return {
          background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
          color: 'white'
        };
      default:
        return {
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white'
        };
    }
  };

  const styles = getStyles();

  return (
    <div
      style={{
        position: 'fixed',
        top: isMobile ? '16px' : '24px',
        right: isMobile ? '16px' : '24px',
        left: isMobile ? '16px' : 'auto',
        zIndex: 99999,
        minWidth: isMobile ? 'auto' : '320px',
        maxWidth: isMobile ? 'calc(100% - 32px)' : '500px',
        ...styles,
        borderRadius: isMobile ? '12px' : '16px',
        padding: isMobile ? '16px 18px' : '20px 24px',
        boxShadow: '0 12px 40px rgba(0,0,0,0.25)',
        display: 'flex',
        alignItems: 'center',
        gap: isMobile ? '12px' : '16px',
        animation: 'slideInRight 0.4s ease-out',
        backdropFilter: 'blur(10px)'
      }}
    >
      <div style={{ flexShrink: 0 }}>
        {getIcon()}
      </div>
      <div style={{ 
        flex: 1, 
        fontSize: isMobile ? '14px' : '15px', 
        fontWeight: '500', 
        lineHeight: '1.5' 
      }}>
        {message}
      </div>
      <button
        onClick={onClose}
        style={{
          background: 'rgba(255,255,255,0.2)',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          padding: isMobile ? '5px' : '6px',
          display: 'flex',
          alignItems: 'center',
          transition: 'all 0.3s',
          color: 'white'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
          e.currentTarget.style.transform = 'scale(1.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
          e.currentTarget.style.transform = 'scale(1)';
        }}
      >
        <X size={isMobile ? 16 : 18} />
      </button>
    </div>
  );
}

export default Toast;
